module.exports = __webpack_public_path__ + "static/img/home_logo3.29fced4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo3.png
// module id = PEnA
// module chunks = 3